export default 'USER_CHANGED_SEARCH_TERM';
